/***
 *
 *   HEADER
 *   Header section with title used in main application (can render children)
 *
 *   PROPS
 *   title: title of the view
 *   children: children to render (optional)
 *
 **********/

// import { useContext } from 'react';
import { type ReactNode } from 'react';
import Style from './header.module.scss';
// import { CurrentProjectContext } from 'contexts/CurrentProjectContext';

interface HeaderProps {
  title?: ReactNode;
  id?: string;
  children?: ReactNode;
}

export function Header(props: HeaderProps) {
  // const { currentProject } = useContext(CurrentProjectContext);

  return (
    <header className={Style.header} id={props.id}>
      {props.title && (
        <>
          <span className="page-title">{props.title}</span>
          {/* {props.title === 'Project' && <span>{currentProject?.name}</span>} */}
        </>
      )}
      {props.children}
    </header>
  );
}
